import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Check, ShieldCheck, Zap, CreditCard } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden py-16 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-141">
      <div className="absolute inset-0 z-0" data-id="element-142">
        <div className="absolute inset-0 bg-gradient-to-b from-warmBrown-dark/60 via-charcoal to-charcoal z-10" data-id="element-143" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_left,rgba(212,168,83,0.08)_0%,transparent_50%)] z-10" data-id="element-144" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="space-y-7" data-id="element-146">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight" data-id="element-147">
            Convertí tu cocina en un ingreso real en 15 días vendiendo focaccias{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-gold to-gold-light" data-id="element-148">
              (aunque empieces desde cero)
            </span>
          </h1>

          <p className="text-xl sm:text-2xl text-cream-muted font-light" data-id="element-149">
            Sin experiencia. Sin local. Con un sistema simple paso a paso que ya
            está generando ingresos reales.
          </p>

          {/* Income value block */}
          <div className="flex items-center gap-2 bg-gold/10 border border-gold/30 rounded-xl px-5 py-3" data-id="element-150">
            <span className="text-2xl" data-id="element-151">💰</span>
            <p className="text-lg sm:text-xl font-semibold text-gold-light" data-id="element-152">
              Podés generar entre $80.000 y $300.000 por mes vendiendo desde tu
              casa
            </p>
          </div>

          {/* Micro trust */}
          <ul className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-x-5 sm:gap-y-2 text-sm text-cream-muted/80" data-id="element-153">
            <li className="flex items-center gap-2" data-id="element-154">
              <Check className="w-4 h-4 text-gold" strokeWidth={3} data-id="element-155" />
              Acceso inmediato
            </li>
            <li className="flex items-center gap-2" data-id="element-156">
              <ShieldCheck className="w-4 h-4 text-gold" data-id="element-157" />
              Pagos seguros con MercadoPago
            </li>
            <li className="flex items-center gap-2" data-id="element-158">
              <CreditCard className="w-4 h-4 text-gold" data-id="element-159" />
              Funciona con débito/crédito
            </li>
          </ul>

          {/* CTA */}
          <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-5 w-full sm:w-auto text-lg font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_30px_rgba(212,168,83,0.35)] hover:shadow-[0_0_50px_rgba(212,168,83,0.55)]" data-id="element-160">
            <span className="relative z-10 flex items-center gap-2" data-id="element-161">
              👉 QUIERO EMPEZAR HOY
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-162" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/25 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-163" />
          </motion.a>
          <p className="text-xs text-cream-muted/50 text-center sm:text-left" data-id="element-164">
            ✓ 7 días de garantía — si no te convence, te devolvemos el dinero
            sin preguntas.
          </p>
        </motion.div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        x: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.15,
        ease: 'easeOut'
      }} className="relative mt-8 lg:mt-0" data-id="element-165">
          <div className="absolute inset-0 bg-gold/15 blur-[60px] rounded-full pointer-events-none" data-id="element-166" />
          <img src="https://cdn.magicpatterns.com/uploads/gDiKgucRP1T9Z2624efsfk/ChatGPT_Image_31_mar_2026,_10_53_59_a.m..png" alt="Ebook Emprendé con Focaccias" className="relative z-10 w-full h-auto rounded-3xl shadow-[0_0_40px_rgba(0,0,0,0.5)] border border-white/10 object-contain" data-id="element-167" />
        </motion.div>
      </div>
    </section>;
}